import React from "react";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";

const HeaderBar = () => {
    return (
        <header>
            <HeaderMobile />
            <HeaderDesktop />
        </header>
    )
}

export default HeaderBar;


// WEBPACK FOOTER //
// ./src/pages/HeaderBar/HeaderBar.jsx